<template>
  <b-container>
    <div v-if="!code || !userId">
        <h3>Invalid Link</h3>
    </div>
    <div v-else>
    <h1>Confirm account</h1>

    <b-alert variant="danger" :show="error != ''">{{ error }}</b-alert>
    
    <b-row>
      <b-col md="6">
        <ValidationObserver v-slot="{ handleSubmit }">
        <b-form @submit.prevent="handleSubmit(confirmAccount)">
            <b-form-group label="Password">
                <ValidationProvider name="Password" :rules="{ required: true, min: 6, regex: /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W)/ }" vid="password" v-slot="{ errors, failedRules }">
                    <b-input type="password" v-model="password" :state="errors[0] ? false : null"></b-input>
                    <b-form-invalid-feedback v-if="failedRules.regex">Password must contain an uppercase character, lowercase character, a digit, and a non-alphanumeric character</b-form-invalid-feedback>
                    <b-form-invalid-feedback v-else>{{ errors[0] }}</b-form-invalid-feedback>
                </ValidationProvider>
            </b-form-group>

            <b-form-group label="Confirm Password">
                <ValidationProvider name="Confirm Password" rules="required|confirmed:password" v-slot="{ errors }">
                    <b-input type="password" v-model="confirm_password" :state="errors[0] ? false : null"></b-input>
                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                </ValidationProvider>
            </b-form-group>

            <b-button type="submit">Confirm</b-button>
        </b-form>
        </ValidationObserver>
      </b-col>
    </b-row>
    </div>
  </b-container>
</template>
<script>
import axios from 'axios';
import { ValidationProvider, ValidationObserver, setInteractionMode } from 'vee-validate';

setInteractionMode('lazy');

export default {
    components: { ValidationProvider, ValidationObserver },
    data() {
        return {
            error: '',
            code: '',
            userId: '',
            password: '',
            confirm_password: ''
        }
    },
    methods: {
        confirmAccount() {
            axios.post('/api/account/confirm', {
                code: this.code,
                userId: this.userId,
                password: this.password
            })
            .then(() => {
                this.$router.push('/login')
            })
            .catch(() => {
                this.error = 'Failed to confirm account';
            })
        }
    },
    created() {
        this.code = this.$route.query.code;
        this.userId = this.$route.query.userId;
    }
}
</script>